import {WinPresentationController} from "../WinPresentationController";
import {TimelineLite} from "gsap";
import {TheRave} from "../../TheRave";
import {TheRaveSymbol} from "../../symbol/TheRaveSymbol";
import {TheRaveSymbolState} from "../../symbol/TheRaveSymbolConfig";
import {TheRaveSound} from "../../sound/TheRaveSound";

export class TransformMsToDJ extends WinPresentationController {

    private _tl: TimelineLite;

    constructor() {
        super("TransformMsToDJ", true);
    }

    protected hasWin(): boolean {
        return TheRave.model.parsedGameData.doTransformToM1;
    }

    protected async createWinAnimation(): Promise<void> {
        const tl: TimelineLite = new TimelineLite(),
            data = TheRave.model.parsedGameData,
            revealToMs: boolean = data.hasXWays && (data.mysterySymbolReveal != "M1" && data.mysterySymbolReveal[0] === "M");
        let  hasTransform:boolean = false,
            reels: string[][] = TheRave.model.parsedGameData.reels.concat();
        data.enhancerReel.forEach((hasEnhancer:boolean,i:number)=>{
            reels[i][3] = hasEnhancer?reels[i+5][0]:reels[i][3];
        });
        //console.log(reels)
        //console.log(data.reels);
        [0, 1, 2, 3, 4].forEach((i: number) => {
            if(!TheRave.model.parsedGameData.doDoubleXways[i]) {
                reels[i].forEach((symbol: string, j: number) => {
                    if ((j > 0 && j < 4) && ((symbol[0] === "M" && symbol != "M1") || (symbol === "XW" && revealToMs))) {
                        hasTransform = true;
                        const transformAnimation: TimelineLite = new TimelineLite();
                        const currentSymbol: TheRaveSymbol = TheRave.reels[i].getSymbol(j, true),
                            newSymbol: TheRaveSymbol = TheRave.reels[i].createSymbol("M1", i, TheRaveSymbolState.NORMAL, currentSymbol.symbolHeight);
                        newSymbol.alpha = 0;
                        transformAnimation.add([
                            () => {
                                TheRave.reels[i].reelView.addSymbol(newSymbol);
                                newSymbol.position.set(currentSymbol.x, currentSymbol.y);
                            },
                            newSymbol.playTransform()
                        ]);
                        transformAnimation.add(() => {
                            newSymbol.alpha = 1;
                            TheRave.reels[i].removeOldSymbol(newSymbol, currentSymbol, j);
                        }, 0.777);
                        tl.add(transformAnimation, 0);
                    }
                });
            }
        });
        if(hasTransform){
            tl.add(()=>TheRaveSound.playSoundEffect(TheRaveSound.M_TO_M1), 0);
        }
        tl.to(this, {duration: 0.1});
        this._tl = tl;
        await Promise.resolve(tl);
    }

    public skip(): void {
        this._tl.timeScale(2);
    }
}
